import { render } from "./ModuleResultSearch.vue?vue&type=template&id=327eaf7e&scoped=true&ts=true"
import script from "./ModuleResultSearch.vue?vue&type=script&lang=ts"
export * from "./ModuleResultSearch.vue?vue&type=script&lang=ts"

import "./ModuleResultSearch.vue?vue&type=style&index=0&id=327eaf7e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-327eaf7e"]])

export default __exports__